export default {
    NOONE: 0,
    ME: 1,
    interlocutor: 2
}